var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Headline } from '../Headline';
export const ProgressCircle = (_a) => {
    var { className, progress = 0, color, children } = _a, props = __rest(_a, ["className", "progress", "color", "children"]);
    const ProgressCircleClasses = classnames('ProgressCircle', className, {
        'ProgressCircle--blue': color === 'blue',
        'ProgressCircle--green': color === 'green',
        'ProgressCircle--red': color === 'red',
        'ProgressCircle--yellow': color === 'yellow',
    });
    function value_limit(val, min, max) {
        return val < min ? min : val > max ? max : val;
    }
    const thickness = 10;
    const radius = 50 - thickness / 2;
    const circumference = radius * 2 * Math.PI;
    const [dashoffset, setDashoffset] = React.useState(circumference);
    React.useEffect(() => {
        setDashoffset(circumference -
            (value_limit(progress, 0, 100) / 100) * circumference);
    }, [circumference, progress]);
    const ProgressCircleComponent = (React.createElement("div", Object.assign({ className: ProgressCircleClasses, "data-anvil-component": "ProgressCircle" }, props),
        React.createElement("svg", { className: "ProgressCircle__svg", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { className: "ProgressCircle__background", strokeDasharray: `${circumference} ${circumference}`, cx: "50", cy: "50", strokeWidth: thickness, r: radius }),
            React.createElement("circle", { className: "ProgressCircle__circle", style: { strokeDashoffset: dashoffset }, strokeDasharray: `${circumference} ${circumference}`, cx: "50", cy: "50", strokeWidth: thickness, r: radius })),
        React.createElement(Headline, { className: "ProgressCircle__children" }, children)));
    return ProgressCircleComponent;
};
//# sourceMappingURL=ProgressCircle.js.map